/* ============
 * Add Batch Log Component
 * ============
 *
 * This is the component for creating batch log
 */
import { mapMutations } from 'vuex';

export default {

  props: {
    errors: {
      type: Array,
      default: [],
    },
  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),
    /*
    * Closes the modal
    */
    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/components/productImportExportErrorReportPopup/productImportExportErrorReportPopup.js